import { Button, Dialog, EditIcon, LinkIcon, Menu, MoreIcon, Popup, ProviderConsumer, TrashCanIcon, Text } from '@fluentui/react-northstar';
import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import AppCSS from '../App.module.css';
import { useSetKBState } from '../AppKBState';
import { kbDataService } from '../shared/services/kb.service';
import { ViewIcon } from '@fluentui/react-icons-mdl2';

interface KnowledgeListMenuProps {
  id: number;
  templateId?: number;
  isTemplate: boolean;
  isUserLicensed: boolean;
}

export const KnowledgeListMenu = (props: KnowledgeListMenuProps) => {
  const { t } = useTranslation();
  const history = useHistory();
  const setState = useSetKBState();
  const [open, setOpen] = useState<boolean>(false);
  const [openDialog, setOpenDialog] = useState<boolean>(false);

  const getDirectLink = async (open: boolean) => {
    const url = `${window.location.protocol}//${window.location.host}/knowledge/${(props.isTemplate ? `template/${props.templateId}` : `article/${props.id}`)}`;
    if (open) {
      window.open(url, "_blank");
    } else {
      await navigator.clipboard.writeText(url);
      toast.success(t('common.link-copied'));
    }
  }

  return (<ProviderConsumer render={globalTheme => (<>
    <Dialog className={AppCSS.confirmDialog} cancelButton={t('knowledge.add-knowledge-modal.button.cancel')} confirmButton={t('common.buttons.confirm')} open={openDialog}
      onCancel={() => setOpenDialog(false)} header={`${t('knowledge.delet-kb-message')}${props.id}`} content={''}
      onConfirm={() => {
        setState(state => { return { ...state, loadingKB: { message: t('knowledge.loading-knowledge-message'), isLoading: true } } });
        kbDataService.deleteAPI([props.id])
          .then(() => {
            setState(state => { return { ...state, deletedKB: [...state.deletedKB, props.id], knowledgeBase: state.knowledgeBase.filter(kb => kb.id !== props.id), tab: 0 }; });
          })
          .catch(console.log)
          .finally(() => {
            setState(state => { return { ...state, loadingKB: { message: '', isLoading: false } } });
          });
      }} />
    <Popup position='below' className="p-0" open={open}
      onOpenChange={(e, { open }) => { setOpen(open); }}
      trigger={<Button icon={<MoreIcon />} circular text iconOnly title={t('knowledge.knowledge-table.more-options')} />}
      content={<Menu vertical pointing className='p-0' activeIndex={-1}
        items={[
          <span key='edit-icon'>
            <EditIcon disabled={!props.isUserLicensed} outline /> &nbsp;<Text content={t('knowledge.knowledge-table.edit')} disabled={!props.isUserLicensed} />
          </span>,
          <span key='view-icon'>
            <ViewIcon /> &nbsp;{t('requests.view')}
          </span>,
          <span key='link-icon'>
            <LinkIcon outline /> &nbsp;{t('common.direct-link')}
          </span>,
          <span key='trash-icon'>
            <TrashCanIcon disabled={!props.isUserLicensed} outline /> &nbsp;<Text content={t('knowledge.knowledge-table.delete')} disabled={!props.isUserLicensed} />
          </span>]}
        onItemClick={(e, p) => {
          setOpen(false);
          if (p.index === 0 && props.isUserLicensed)
            history.push(`/servicecatalog/${props.id}`);
          else if (p.index === 1)
            getDirectLink(true);
          else if (p.index === 2)
            getDirectLink(false);
          else if (p.index === 3 && props.isUserLicensed)
            setOpenDialog(true);
        }} />} />
  </>)} />);
}